import { Action, Reducer, combineReducers, configureStore } from '@reduxjs/toolkit';
import { RESET_STATE_ACTION_TYPE } from './actionCreators';
import { initialState as AppInitialState, appReducer } from './app/slice';
import { initialState as AuthInitialState, authReducer } from './auth/slice';
import { initialState as DashboardInitialState, dashboardReducer } from './dashboard/slice';
import { initialState as PatientsInitialState, patientsReducer } from './patients/slice';
import { initialState as UsersInitialState, usersReducer } from './users/slice';

const combinedReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  app: appReducer,
  patients: patientsReducer,
  dashboard: dashboardReducer,
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer: Reducer = (state: RootState, action: Action) => {
  if (action.type === RESET_STATE_ACTION_TYPE) {
    state = {
      auth: AuthInitialState,
      users: UsersInitialState,
      app: AppInitialState,
      patients: PatientsInitialState,
      dashboard: DashboardInitialState,
    } as RootState;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Inferred type: {posts: PostsState, comments: CommentsState, users: AuthState}
export type AppDispatch = typeof store.dispatch;
